<!-- =========================================================================================
    File Name: Error404.vue
    Description: 404 Page
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div class="h-screen flex w-full bg-img">
    <div
      class="vx-col flex items-center justify-center flex-col sm:w-1/2 md:w-3/5 lg:w-3/4 xl:w-1/2 mx-auto text-center"
    >
      <img
        src="@/assets/images/pages/ImpulsoFitness_Logo_219.png"
        class="mx-auto mb-8 max-w-full"
      />
      <h1 class="sm:mx-0 mx-4 mb-4 text-5xl d-theme-heading-color">
        ¡Bienvenido a Impulso Fitness!
      </h1>
      <h2 class="sm:mx-0 mx-4 sm:mb-5 d-theme-text-inverse">
        Revisa tu correo para recibir la información de tu nueva membresía.
      </h2>
      <h3 class="sm:mx-0 mx-4 mb-4 sm:mb-16">
        Acercate a nuestras instalaciones para agregar tu huella digital y poder
        acceder a nuestras instalaciones.
      </h3>
      <vs-button color="#197CBF" size="large" @click="goToImpulso">
        Crear Usuario
      </vs-button>
      <!--            <p class="sm:mx-0 mx-4 mb-4 sm:mb-16 d-theme-text-inverse">Consulta tu correo electronico.</p>-->
      <!-- <vs-button size="large" to="/">Back to Home</vs-button> -->
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {};
  },
  methods: {
    goToImpulso() {
      const url = atob(this.$route.query.URL);
      window.open(url, "_blank");
    },
  },
  mounted() {},
};
</script>
